import { CommonMessage } from '@frontend/lang';

/** Horizontal “or” divider above secondary wizard method buttons. */
export const MethodOrDivider = () => (
    <div className='inline-flex items-center justify-center gap-4 self-stretch'>
        <div className='bg-border-default h-px w-24' />
        <div className="text-foreground-default justify-start text-center font-['Montserrat'] text-base font-medium">{CommonMessage.WIZARD.OR}</div>
        <div className='bg-border-default h-px w-24' />
    </div>
);
